import React from "react"

import {FormattedMessage, useIntl} from "@irati/utils/lang"

import {Wallet} from "@irati/types"
import Spacing from "@irati/ui/src/Spacing"

import {StyledScheduledTransfers, StyledStatementItems, StyledTabs, DesktopHeader} from "./styled"

interface Props {
  isPhone: boolean
  wallet: Wallet
}

export default function Cash({isPhone, wallet}: Props) {
  const {formatMessage} = useIntl()

  return (
    <Spacing marginTop={4}>
      <DesktopHeader marginBottom={2}>
        <FormattedMessage id="wallet.transactions.title.cash" />
      </DesktopHeader>
      <StyledTabs
        mountOnEnter
        unmountOnExit
        fullWidth={isPhone}
        tabs={[
          {
            title: formatMessage({id: "wallet.transactions.tabs.cleared.title"}),
            key: "cleared",
            component: <StyledStatementItems wallet={wallet} />
          },
          {
            title: formatMessage({id: "wallet.transactions.tabs.pending.title"}),
            key: "pending",
            component: <StyledScheduledTransfers wallet={wallet} />
          },
          {
            title: formatMessage({id: "wallet.transactions.tabs.cancelled.title"}),
            key: "cancelled",
            component: <StyledScheduledTransfers isCancelledTransfers wallet={wallet} />
          }
        ]}
      />
    </Spacing>
  )
}
